<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <h1 class="mat-headline-3" i18n>Import online purchases automatically</h1>
        <p i18n>On average, our users make close to 100 EUR in selling past online purchases.</p>
        <p i18n>In order to find what you could sell, please allow our AI to identify all purchase receipts from your inbox and present you a list of items you have bought in the past.</p>
        <scan-gmail-button type="mat-raised-button" color="accent" (onScanStarted)="integrated()" i18n-label="button label" label="Connect to Gmail"></scan-gmail-button>
        <div>
          <mat-icon fontSet="material-symbols-outlined" style="float:left;font-size: 40px;line-height: 40px;height: 40px; width:40px;">priority_high</mat-icon>
          <p style="margin-top: 32px" i18n>
            Please allow up to 1 minute to retrieve all the purchases. Thank you for your patience.
          </p>
        </div>
      </div>
      
      <div style="text-align: center" class="right mdc-layout-grid__cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <img ngSrc="/access-inbox/access_inbox_1.webp" ngSrcset="1x, 2x, 3x" width="245" height="497" priority/>
      </div>
    </div>
  </div>
</div>